import React, { useEffect, useState } from "react";
import { Button } from "./ui/button";
import { Download, X } from "lucide-react";

const DISMISSED_KEY = "rcs-pwa-install-dismissed-v1";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      try { if (localStorage.getItem(DISMISSED_KEY)) return; } catch {}
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setVisible(false);
    setDeferred(null);
  };

  const dismiss = () => {
    try { localStorage.setItem(DISMISSED_KEY, new Date().toISOString()); } catch {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-40 max-w-sm animate-rise"
      data-testid="pwa-install-prompt"
      role="dialog"
      aria-label="Install RapidCare SA"
    >
      <div className="bg-white rounded-lg shadow-2xl border border-slate-200 p-4 flex items-start gap-3">
        <div className="w-10 h-10 rounded-md bg-[#0B5FFF] text-white flex items-center justify-center flex-shrink-0">
          <Download className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <div className="font-heading font-semibold text-sm text-[#111827]">Install RapidCare SA</div>
          <p className="text-xs text-slate-600 mt-1 leading-relaxed">
            Add to your home screen for one-tap access, offline protocols at the bedside, and a full-screen experience.
          </p>
          <div className="mt-3 flex gap-2">
            <Button onClick={install} size="sm" className="bg-[#0B5FFF] hover:bg-[#0A54E0] h-8 text-xs px-4" data-testid="pwa-install-accept">
              Install
            </Button>
            <Button onClick={dismiss} size="sm" variant="outline" className="h-8 text-xs px-4" data-testid="pwa-install-dismiss">
              Not now
            </Button>
          </div>
        </div>
        <button onClick={dismiss} className="text-slate-400 hover:text-slate-700" aria-label="Close">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
